import type { PaginatedResponse } from '@/shared/types/entity';

export type PaginatedApiResponse<T> = PaginatedResponse<T> | {
  data: T[];
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
};

export const normalizePaginatedResponse = <T>(response: PaginatedApiResponse<T>): PaginatedResponse<T> => {
  if (!('meta' in response)) {
    return response;
  }

  return {
    data: response.data,
    currentPage: response.meta.current_page,
    perPage: response.meta.per_page,
    total: response.meta.total,
    lastPage: response.meta.last_page,
  };
};
